import isEmail from 'validator/lib/isEmail'

export default Validator => {
	Validator.register(
		'email',
		function(value = '') {
			return isEmail(value.replace(/\s/g, ''))
		},
		'Du må fylle ut e-postadresse ',
	)
}
